import { useContext, useMemo } from 'react';
import { CONTENT_PLATFORM_PROPERTY_NAME, contentIsPublished, contentIsPublishedWithScheduledUpdate, contentIsScheduled, getContentPropertyValue } from 'content-management-data-lib';
import { PublishTypes } from '../../../constants/PublishTypes';
import { ContentCrmObjectContext } from '../ContentCrmObjectProvider';
const useContentCrmObjectContext = () => {
  const contentCrmObjectContext = useContext(ContentCrmObjectContext);
  if (!contentCrmObjectContext) {
    throw new Error('useContentCrmObject must be used within a ContentCrmObjectProvider');
  }
  return contentCrmObjectContext;
};
const useContentCrmObject = () => {
  const {
    contentCrmObject,
    contentCrmObjectLoading,
    contentCrmObjectError,
    reconcileContentCrmObjectForPublishActions,
    contentCrmObjectId,
    contentObjectType,
    isStagingV2,
    stagedPageDomainName,
    refetchStagedPage
  } = useContentCrmObjectContext();
  return useMemo(() => {
    let contentCrmObjectPublishType = PublishTypes.publish;
    let contentCrmObjectData = {};
    if (contentCrmObject) {
      const isContentCrmObjectPublished = contentIsPublished(contentCrmObject);
      const isContentCrmObjectScheduled = contentIsScheduled(contentCrmObject);
      const isContentCrmObjectScheduledToBeUnpublished = !!getContentPropertyValue(contentCrmObject, CONTENT_PLATFORM_PROPERTY_NAME.SCHEDULED_UNPUBLISH_DATE);
      const isContentCrmObjectPublishedWithScheduledUpdate = contentIsPublishedWithScheduledUpdate(contentCrmObject);
      if (isContentCrmObjectScheduled || isContentCrmObjectPublishedWithScheduledUpdate) {
        contentCrmObjectPublishType = PublishTypes.schedule;
      } else if (isContentCrmObjectPublished) {
        contentCrmObjectPublishType = PublishTypes.update;
      }
      contentCrmObjectData = {
        isContentCrmObjectPublished,
        isContentCrmObjectScheduled,
        isContentCrmObjectScheduledToBeUnpublished,
        isContentCrmObjectPublishedWithScheduledUpdate,
        contentCrmObject
      };
    }
    return Object.assign({
      isContentCrmObjectLoading: contentCrmObjectLoading,
      contentCrmObjectError,
      contentCrmObjectPublishType,
      contentCrmObjectId,
      contentObjectType,
      reconcileContentCrmObjectForPublishActions,
      isStagingV2,
      stagedPageDomainName,
      refetchStagedPage
    }, contentCrmObjectData);
  }, [contentCrmObject, contentCrmObjectLoading, contentCrmObjectError, reconcileContentCrmObjectForPublishActions, contentObjectType, contentCrmObjectId, isStagingV2, stagedPageDomainName, refetchStagedPage]);
};
export default useContentCrmObject;